var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return (_vm.$slots.default && _vm.$slots.default[0])?_c('span',{staticClass:"Icon",class:_vm.$slots.default[0].text,style:({
        fontSize: _vm.icon_font_size,
    }),attrs:{"aria-hidden":"true"}}):_vm._e()}
var staticRenderFns = []

export { render, staticRenderFns }